<template>
  <section class="notes-section">
    <div class="notes-container">
      <div class="notes-control-bar">
        <el-button style="width: 100%" class="notes-control-bar-button" type="primary" icon="el-icon-plus" @click.stop="apiPostNote">Nova anotação</el-button>
        <el-button class="notes-control-bar-button" type="info" icon="el-icon-close" @click.stop="closeNotes"></el-button>
      </div>
      <el-collapse class="note-card" v-for="note in notes" :key="note.note_id">
        <el-collapse-item name="1" class="note-card-item">
          <template slot="title">
            <!-- <span>{{ note.title }}</span> -->
            <el-input class="note-title-input" type="text" size="small" v-model="note.title" @change="apiPutNoteTitle(note)"></el-input>
            <el-button class="note-card-edit" type="text" icon="el-icon-edit"></el-button>
            <el-button class="note-card-delete" type="text" icon="el-icon-delete" @click.stop="apiDeleteNote(note)"></el-button>
          </template>
          <div class="notes-content">
            <!-- <p>{{ note.description }}</p> -->
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10 }" placeholder="Please input" v-model="note.notes" @change="apiPutNote(note)"></el-input>
            <!-- <p>{{ note.notes }}</p> -->
            <el-collapse class="collapsable-item">
              <el-collapse-item title="Arquivos" name="1">
                <el-upload class="drag-upload" drag action="" :http-request="uploadFile" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Arraste aqui ou
                    <em>clique para subir</em>
                  </div>
                </el-upload>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </section>
</template>

<script>
import api from '@/services/api.js';

export default {
  name: 'Notes',

  data() {
    return {
      notes: [],
      note: null,
      isMenuCollapsed: false,
      isPortrait: false,
      fileList: [],
    };
  },

  methods: {
    apiGetUserNotes() {
      // http://localhost:3333/api/event/c263ca40-0c0d-11eb-be12-f990b61f0ef3/note?user_id=c263ca40-0c0d-11eb-be12-f990b61f0ef3

      api
        .get(`/event/${this.$store.state.eventId}/note?user_id=${this.$store.state.user.id}`)
        .then((response) => {
          // console.log("apiGetUserNotes", response);
          this.notes = response.data.reverse().map((note) => {
            note.activeSections = ['1'];
            return note;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    apiPostNote() {
      const payload = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: null,
        date: '2021-04-14 00:00:00',
        title: `Anotação ${this.notes.length + 1}`,
        description: '',
        notes: 'Test note. Here goes the text. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        links: '',
        people: '',
        status: '',
      };
      api
        .post(`/event/${this.$store.state.eventId}/note`, payload)
        .then((response) => {
          // console.log("apiPostNote", response);
          this.apiGetUserNotes();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    apiPutNote(note) {
      const payload = {
        title: note.title,
        description: note.description,
        notes: note.notes,
        links: note.links,
        people: note.people,
        status: note.status,
      };
      api
        .put(`/event/${this.$store.state.eventId}/note/${note.note_id}`, payload)
        .then((response) => {
          this.apiGetUserNotes();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    apiDeleteNote(note) {
      this.$modal.show('dialog', {
        title: 'Remover anotação',
        text: 'Tem certeza que deseja remover esta anotação?',
        buttons: [
          {
            title: 'Ok',
            handler: () => {
              api
                .delete(`/event/${this.$store.state.eventId}/note/${note.note_id}`)
                .then((response) => {
                  console.log('apiDeleteNote', response);
                  this.apiGetUserNotes();
                })
                .catch((err) => {
                  console.error(err);
                });
              this.$modal.hide('dialog');
            },
          },
          {
            title: 'Cancelar',
            default: true,
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },

    apiEditNote(note) {
      console.log('apiEditNote', note);
    },

    uploadFile(data) {
      console.log('uploadFile', { data });
    },

    handlePreview(file) {
      console.log('handlePreview', { file });
    },

    handleRemove(file) {
      console.log('handleRemove', { file });
    },

    closeNotes() {
      this.$emit('close');
    },
  },

  beforeMount() {
    this.apiGetUserNotes();
  },

  mounted() {
    // setTimeout(() => {
    //   this.apiPostNote();
    // }, 5000);
  },
};
</script>

<style lang="scss">
.notes-section {
  position: fixed;
  right: 0;
  top: 99px;

  @include media('<phone') {
    top: 50px;
  }

  padding: 10px 10px 50px 10px;
  height: 100dvh;
  z-index: 1;
  pointer-events: none;

  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
.notes-container {
  position: relative;
  pointer-events: auto;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
}

.notes-control-bar {
  position: relative;
  width: 100%;

  display: flex;
}

.note-card {
  position: relative;
  width: 260px;
  border-radius: 4px;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  .note-title-input {
    .el-input__inner {
      padding: 0 0 0 10px;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      border: none;
    }
  }

  .note-card-edit {
    position: relative;
    margin-left: auto;
  }

  .note-card-delete {
    position: relative;
  }

  .note-card-item {
    position: relative;
    width: 100%;

    .el-collapse-item__wrap {
      border-bottom: none;
    }

    .el-collapse-item__arrow {
      margin-right: 2px;
      margin-left: 10px;
      display: none;
    }

    .el-collapse-item__header {
      padding: 10px;
    }
    .el-collapse-item__content {
      padding: 0 0 4px 0;
    }
  }
}

.notes-content {
  position: relative;
  padding: 10px;
  padding-bottom: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;

  .collapsable-item {
    width: 100%;
  }

  .drag-upload {
    width: 100%;

    display: flex;
    flex-direction: column;

    .el-upload-dragger {
      width: 100%;
    }
  }
}
</style>
